<template>
  <header class="header">
    <div class="logo-container">
      <a href="" class="logo">
        <img src="/img/logo.svg" height="35" alt="OZIWEB" />
      </a>
      <div class="visible-xs toggle-sidebar-left" data-toggle-class="sidebar-left-opened" data-target="html" data-fire-event="sidebar-left-opened">
        <em class="fa fa-bars" aria-label="Toggle sidebar" ></em>
      </div>
    </div>

    <div class="header-right">
      
      <span class="separator"></span>
      
     <a href="">ENGLISH</a>
     
      <span class="separator"></span>
      <div id="userbox" class="userbox" >
        <a style="cursor:pointer" v-on:click="openbox">
          <div class="profile-info">
            <span class="name">{{firstName}} {{lastName}}</span>
            <span class="role">{{privilege}}</span>
          </div>
          <em class="fa custom-caret"></em>
        </a>
        <div v-show="showbox" class="logoutbox">
          
              <a v-on:click="logout()" style="cursor:pointer"><em class="fa fa-power-off"></em> Se déconnecter</a>
           
        </div>
      </div>
    </div>
  </header>
</template>


<script>
export default {
  data: function() {return {
    showbox: false,

  }},
  computed: {
    firstName() {
      return localStorage.firstName;
    },
    lastName() {
      return localStorage.lastName;
    },
    privilege() {
      return localStorage.privilege;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('jwt');
      this.$router.push({name:'login'});
    },
    openbox: function() {
      this.showbox=!this.showbox;

    }
  }
}
</script>

<style>

.logoutbox
{
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;

  -webkit-background-clip: padding-box;

  background-clip: padding-box;

  border: 1px solid #ccc;

  border: 1px solid rgba(0, 0, 0, .15);

  border-radius: 4px;
  font-size: 13px;

  text-align: center;
  padding:20px 20px

}

</style>
